import { Get } from 'type-fest';
import { get, isEmpty } from 'lodash';

export const getter = <TData, TPath extends string>(
  object: TData,
  path: TPath
) => get(object, path) as Get<TData, TPath>;

export const getObjectScore = <T extends Record<string, unknown>>(
  obj: T,
  fields: readonly (keyof T)[]
) => {
  return fields.reduce((acc, field) => {
    // If array, count the length
    if (Array.isArray(obj[field])) return acc + obj[field].length;
    // If object, count the number of non-empty values
    if (typeof obj[field] === 'object')
      return (
        acc +
        Object.values(obj[field] || {}).filter((val) => !isEmpty(val)).length
      );
    // Otherwise, count 1 if the field is truthy
    return acc + (!isEmpty(obj[field]) ? 1 : 0);
  }, 0);
};
